import LoadingButton from "@mui/lab/LoadingButton";
import DownloadIcon from '@mui/icons-material/Download';
import {useState} from "react";
import {ApiUrl} from "../../../auth/authMethods";
import axios from "axios";
import {getPaymentFileName} from "./getPaymentFileName";

export default function DownloadAllFiles({type, data}) {

    const [downloading, setDownloading] = useState(false)

    const downloadAll = async () => {
        setDownloading(true);

        try {
            // Filtra os pagamentos conforme a lógica original
            const pagamentosParaDownload = data.filter(
                (pagamento) => !(type === 'receipt' && pagamento.status !== 'PAGO')
            );

            for (const item of pagamentosParaDownload) {
                const url = `${ApiUrl}/pagamentos/${type}/${item?.id}`;
                const axiosConfig = {
                    method: 'get',
                    url: url,
                    responseType: 'blob',
                };

                try {
                    const response = await axios(axiosConfig);

                    const blob = new Blob([response.data], {type: 'application/octet-stream'});

                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = getPaymentFileName(item, type)
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } catch (error) {
                    console.error(`Erro ao gerar o arquivo para o item ${item.id}:`, error);
                }
            }
        } catch (error) {
            console.error('Erro ao baixar todos os arquivos:', error);
        } finally {
            setDownloading(false);
        }
    };


    return <span className="button-show" style={{cursor: "pointer", marginRight: '1%'}}>
        <LoadingButton
            onClick={downloadAll}
            loading={downloading}
            loadingPosition="start"
            startIcon={<DownloadIcon/>}
            variant="contained"
            className={''}
        >
            <span>
                &nbsp;Todos os {type === 'receipt' ? 'Comprovantes' : 'Relatórios'}
            </span>
        </LoadingButton>
    </span>
}